export const GET_OVERRIDES_LIST = 'OVERRIDES:GET_OVERRIDES_LIST';
export const GET_OVERRIDES_LIST_SUCCESS = 'OVERRIDES:GET_OVERRIDES_LIST_SUCCESS';
export const GET_OVERRIDES_LIST_FAILURE = 'OVERRIDES:GET_OVERRIDES_LIST_FAILURE';
export const RESET_OVERRIDES_LIST = 'OVERRIDES:RESET_OVERRIDES_LIST';

export const GET_OVERRIDE_DETAILS = 'OVERRIDES:GET_OVERRIDE_DETAILS';
export const GET_OVERRIDE_DETAILS_SUCCESS = 'OVERRIDES:GET_OVERRIDE_DETAILS_SUCCESS';
export const GET_OVERRIDE_DETAILS_FAILURE = 'OVERRIDES:GET_OVERRIDE_DETAILS_FAILURE';
export const RESET_OVERRIDE_DETAILS = 'OVERRIDES:RESET_OVERRIDE_DETAILS';

export const GET_OVERRIDE_REASONS = 'OVERRIDES:GET_OVERRIDE_REASONS';
export const GET_OVERRIDE_REASONS_SUCCESS = 'OVERRIDES:GET_OVERRIDE_REASONS_SUCCESS';
export const GET_OVERRIDE_REASONS_FAILURE = 'OVERRIDES:GET_OVERRIDE_REASONS_FAILURE';
export const SET_OVERRIDES_SEARCH_PARAMS = 'OVERRIDES:SET_OVERRIDES_SEARCH_PARAMS';
export const CLEAR_OVERRIDES_SEARCH_PARAMS = 'OVERRIDES:CLEAR_OVERRIDES_SEARCH_PARAMS';

export const REASSIGN_OVERRIDE = 'OVERRIDES:REASSIGN_OVERRIDE';
export const REASSIGN_OVERRIDE_SUCCESS = 'OVERRIDES:REASSIGN_OVERRIDE_SUCCESS';
export const REASSIGN_OVERRIDE_FAILURE = 'OVERRIDES:REASSIGN_OVERRIDE_FAILURE';
export const RESET_REASSIGN_OVERRIDE = 'OVERRIDES:RESET_REASSIGN_OVERRIDE';

export const DENY_OVERRIDE = 'OVERRIDES:DENY_OVERRIDE';
export const DENY_OVERRIDE_SUCCESS = 'OVERRIDES:DENY_OVERRIDE_SUCCESS';
export const DENY_OVERRIDE_FAILURE = 'OVERRIDES:DENY_OVERRIDE_FAILURE';
export const RESET_DENY_OVERRIDE = 'OVERRIDES:RESET_DENY_OVERRIDE';

export const GET_REASSIGN_OVERRIDE_USERS = 'OVERRIDES:GET_REASSIGN_OVERRIDE_USERS';
export const GET_REASSIGN_OVERRIDE_USERS_SUCCESS = 'OVERRIDES:GET_REASSIGN_OVERRIDE_USERS_SUCCESS';
export const GET_REASSIGN_OVERRIDE_USERS_FAILURE = 'OVERRIDES:GET_REASSIGN_OVERRIDE_USERS_FAILURE';
export const RESET_REASSIGN_OVERRIDE_USERS = 'OVERRIDES:RESET_REASSIGN_OVERRIDE_USERS';

export const EDIT_PRICE_OVERRIDE = 'OVERRIDES:EDIT_PRICE_OVERRIDE';
export const EDIT_PRICE_OVERRIDE_SUCCESS = 'OVERRIDES:EDIT_PRICE_OVERRIDE_SUCCESS';
export const EDIT_PRICE_OVERRIDE_FAILURE = 'OVERRIDES:EDIT_PRICE_OVERRIDE_FAILURE';
export const RESET_EDIT_PRICE_OVERRIDE = 'OVERRIDES:RESET_EDIT_PRICE_OVERRIDE';

export const APPROVE_OVERRIDE = 'OVERRIDES:APPROVE_OVERRIDE';
export const APPROVE_OVERRIDE_SUCCESS = 'OVERRIDES:APPROVE_OVERRIDE_SUCCESS';
export const APPROVE_OVERRIDE_FAILURE = 'OVERRIDES:APPROVE_OVERRIDE_FAILURE';
export const RESET_APPROVE_OVERRIDE = 'OVERRIDES:RESET_APPROVE_OVERRIDE';

export const CANCEL_OVERRIDE = 'OVERRIDES:CANCEL_OVERRIDE';
export const CANCEL_OVERRIDE_SUCCESS = 'OVERRIDES:CANCEL_OVERRIDE_SUCCESS';
export const CANCEL_OVERRIDE_FAILURE = 'OVERRIDES:CANCEL_OVERRIDE_FAILURE';
export const RESET_CANCEL_OVERRIDE = 'OVERRIDES:RESET_CANCEL_OVERRIDE';

export const getOverridesList = (data) => {
    return { type: GET_OVERRIDES_LIST, payload: data };
};

export const getOverrideDetails = (data) => {
    return { type: GET_OVERRIDE_DETAILS, payload: data };
};

export const resetOverrideDetails = () => {
    return { type: RESET_OVERRIDE_DETAILS };
};

export const getOverrideReasons = (data) => {
    return { type: GET_OVERRIDE_REASONS, payload: data };
};

export const editPriceOverride = (data) => {
    return { type: EDIT_PRICE_OVERRIDE, payload: data };
};

export const resetEditPriceOverride = () => {
    return { type: RESET_EDIT_PRICE_OVERRIDE };
};

export const setOverridesSearchParams = (params) => {
    return { type: SET_OVERRIDES_SEARCH_PARAMS, payload: params };
};

export const clearOverridesSearchParams = () => {
    return { type: CLEAR_OVERRIDES_SEARCH_PARAMS };
};

export const resetOverridesList = () => {
    return { type: RESET_OVERRIDES_LIST };
};

export const reassignOverride = (data) => {
    return { type: REASSIGN_OVERRIDE, payload: data };
};

export const denyOverride = (data) => {
    return { type: DENY_OVERRIDE, payload: data };
};

export const resetDenyOverride = () => {
    return { type: RESET_DENY_OVERRIDE };
};

export const addDenyOverrideComments = (data) => {
    return { type: 'OVERRIDES:ADD_OVERRIDE_DENY_COMMENTS', payload: data };
};

export const resetReassignOverride = () => {
    return { type: RESET_REASSIGN_OVERRIDE };
};

export const getReassignOverrideUsers = (data) => {
    return { type: GET_REASSIGN_OVERRIDE_USERS, payload: data };
};

export const resetReassignOverrideUsers = () => {
    return { type: RESET_REASSIGN_OVERRIDE_USERS };
};

export const approveOverride = (data) => {
    return { type: APPROVE_OVERRIDE, payload: data };
};

export const resetApproveOverride = () => {
    return { type: RESET_APPROVE_OVERRIDE };
};

export const cancelOverride = (data) => {
    return { type: CANCEL_OVERRIDE, payload: data };
};

export const resetCancelOverride = () => {
    return { type: RESET_CANCEL_OVERRIDE };
};
